import { useEffect } from 'react'
import { useLocalStorage } from './use-local-storage'
import { isKnownMarket } from '../utils/markets'

const PREFERRED_MARKET_LOCAL_STORAGE_KEY = 'preferred-market'

export function usePreferredMarketLocalStorage(initialValue?: string) {
  const [value, setValue] = useLocalStorage(
    PREFERRED_MARKET_LOCAL_STORAGE_KEY,
    initialValue
  )

  // A stored market must be one we currently support: stale handles (e.g. the
  // pre-ACR-20 'NC/greensboro') would otherwise redirect users to a
  // permanently empty page. Unknown values are treated as unset so the picker
  // shows.
  const isStale = value !== undefined && !isKnownMarket(value)

  // Clear the rejected entry: useLocalStorage's write-back effect would
  // otherwise rewrite the raw stale value on every mount, making it immortal.
  useEffect(() => {
    if (isStale) {
      setValue(undefined)
      try {
        localStorage.removeItem(PREFERRED_MARKET_LOCAL_STORAGE_KEY)
      } catch (error) {
        console.warn('Failed to remove stale preferred market:', error)
      }
    }
  }, [isStale, setValue])

  return [isStale ? undefined : value, setValue] as const
}
